import {MAuthorization} from "@elte/translate-backend/interface/authorization"

import {app} from "./initialFethersjs"
import TResponseLogin = MAuthorization.TResponseLogin;
import TRequestLogin = MAuthorization.TRequestLogin;


export class AuthorizationApi implements MAuthorization.IAuthorization {

    login(request: { strategy: "local", email: string, password: string }): Promise<TResponseLogin>
    login(request: { strategy: "jwt", accessToken: string }): Promise<TResponseLogin>
    login(request: TRequestLogin) {

        return app.authenticate({
            strategy: request.strategy,
            email: request.email,
            password: request.password
        }).then((response) => {
            window.sessionStorage.setItem("apiToken", response.accessToken);
            return response
        })
    }

    relogin(): Promise<TResponseLogin> {
        return app.reAuthenticate().then(value => {
            return value as TResponseLogin
        })
    }

    logout() {
        return app.logout().then(value => null)
    }
}
